import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "dotenv/config";
import LoginOTPPage from "./pages/LoginOTPPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import CartPage from "./pages/CartPage";
import FavouriteProductPage from "./pages/FavouriteProductPage";
import SellerPage from "./pages/SellerPage";
import FAQPage from "./pages/FAQPage";
import PaymentPage from "./pages/PaymentPage";
import GoogleOAuth from "./pages/GoogleOAuth";
import FacebookOAuth from "./pages/FacebookOAuth";
import TikTokOAuth from "./pages/TikTokOAuth";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import EmailConfirm from "./pages/EmailConfirm";
import EmailReceiveInvoiceConfirm from "./pages/EmailReceiveInvoiceConfirm";
import AuthGuard from "./middleware/AuthGuard";
import CheckoutPage from "./pages/CheckoutPage";
import UserResetPassPage from "./pages/UserResetPassPage";
import SellerProductPage from "./pages/SellerProductPage";
import UserProfilePage from "./pages/UserProfilePage";
import NavigationProvider from "./context/navigation";
import TransactionPage from "./pages/TransactionPage";
import UserOrderListPage from "./pages/UserOrderListPage";
import SellerRegisterPage from "./pages/SellerRegisterPage";
import AdminPage from "./pages/AdminPage";
import AdminNavigationProvider from "./context/Admin_context";
import GenOTPPage from "./pages/GenOTPPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import ProductDetailPage from "./pages/ProductDetailPage";

function App() {
  return (
    <div className="App">
      <NavigationProvider>
        <AdminNavigationProvider>
          <Routes>
            <Route path="/">
              <Route
                index
                element={
                  <AuthGuard Component={LoginPage} requireNotLogin={true} />
                }
              />
              {/* Start */}
              <Route
                path="login"
                element={
                  <AuthGuard Component={LoginPage} requireNotLogin={true} />
                }
              />
              <Route
                path="loginotp"
                element={
                  <AuthGuard Component={LoginOTPPage} requireNotLogin={true} />
                }
              />
              <Route path="signup">
                <Route
                  index
                  element={
                    <AuthGuard Component={SignupPage} requireNotLogin={true} />
                  }
                />
                <Route
                  path="otp"
                  element={
                    <AuthGuard Component={GenOTPPage} requireNotLogin={true} />
                  }
                />
              </Route>
              <Route
                path="reset-password"
                element={
                  <AuthGuard
                    Component={ResetPasswordPage}
                    requireNotLogin={true}
                  />
                }
              />
              <Route
                path="google-oauth"
                element={
                  <AuthGuard Component={GoogleOAuth} requireNotLogin={true} />
                }
              />
              <Route
                path="facebook-oauth"
                element={
                  <AuthGuard Component={FacebookOAuth} requireNotLogin={true} />
                }
              />
              <Route
                path="tiktok-oauth"
                element={
                  <AuthGuard Component={TikTokOAuth} requireNotLogin={true} />
                }
              />
              <Route
                path="confirm-email"
                element={
                  <AuthGuard Component={EmailConfirm} requireNotLogin={true} />
                }
              />
              <Route
                path="confirm-email-receive-invoice"
                element={
                  <AuthGuard
                    Component={EmailReceiveInvoiceConfirm}
                    requireNotLogin={true}
                  />
                }
              />
              <Route path="seller">
                <Route
                  index
                  element={
                    <AuthGuard
                      Component={SellerPage}
                      requireLogin={false}
                      requireRole={[4]}
                    />
                  }
                />
                <Route
                  path="home"
                  element={
                    <AuthGuard
                      Component={SellerPage}
                      requireLogin={true}
                      requireRole={[4]}
                    />
                  }
                />
                <Route
                  path="products"
                  element={
                    <AuthGuard
                      Component={SellerProductPage}
                      requireLogin={true}
                      requireRole={[4]}
                    />
                  }
                />
                <Route
                  path="register"
                  element={
                    <AuthGuard
                      Component={SellerRegisterPage}
                      requireLogin={true}
                      requireRole={[5]}
                    />
                  }
                />
              </Route>
              <Route
                path="home"
                element={<AuthGuard Component={HomePage} requireLogin={true} />}
              />
              <Route
                path="/product/:productId"
                element={
                  <AuthGuard
                    Component={ProductDetailPage}
                    requireLogin={true}
                  />
                }
              />
              <Route path="products/">
                <Route
                  index
                  element={<AuthGuard Component={ProductsPage} />}
                  requireLogin={true}
                />
                <Route
                  path="favourite"
                  element={
                    <AuthGuard
                      Component={FavouriteProductPage}
                      requireLogin={true}
                    />
                  }
                />
              </Route>
              <Route
                path="cart"
                element={<AuthGuard Component={CartPage} requireLogin={true} />}
              />
              <Route path="terms-of-service" element={<TermsOfServicePage />} />
              <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="faq" element={<FAQPage />} />
              <Route
                path="orders"
                element={
                  <AuthGuard
                    Component={UserOrderListPage}
                    requireLogin={true}
                  />
                }
              />
              <Route path="user">
                <Route
                  index
                  element={
                    <AuthGuard
                      Component={UserProfilePage}
                      requireLogin={true}
                    />
                  }
                />
                <Route
                  path="profile"
                  element={
                    <AuthGuard
                      Component={UserProfilePage}
                      requireLogin={true}
                    />
                  }
                />
                <Route
                  path="reset-password"
                  element={
                    <AuthGuard
                      Component={UserResetPassPage}
                      requireLogin={true}
                    />
                  }
                />
              </Route>
              <Route
                path="checkout"
                element={
                  <AuthGuard Component={CheckoutPage} requireLogin={true} />
                }
              />
              <Route path="payment">
                <Route
                  index
                  element={
                    <AuthGuard Component={PaymentPage} requireLogin={true} />
                  }
                />
                <Route
                  path="status"
                  index
                  element={
                    <AuthGuard
                      Component={TransactionPage}
                      requireLogin={true}
                    />
                  }
                />
              </Route>
            </Route>
            <Route path="admin">
              <Route
                index
                element={
                  <AuthGuard
                    Component={AdminPage}
                    requireLogin={true}
                    requireRole={[1, 0]}
                  />
                }
              />
              <Route
                path="login"
                element={
                  <AuthGuard
                    Component={AdminLoginPage}
                    requireNotLogin={true}
                  />
                }
              />
            </Route>
            {/* End */}
          </Routes>
        </AdminNavigationProvider>
      </NavigationProvider>
    </div>
  );
}

export default App;
